export enum AccredibleBruteForceErrorStatus {
  INVALID_CREDENTIALS = 'invalid_credentials',
  INVALID_CREDENTIALS_THIRD_ATTEMPT = 'invalid_credentials_with_two_remaining_attempts',
  INVALID_CREDENTIALS_FOURTH_ATTEMPT = 'invalid_credentials_with_last_remaining_attempt',
  ACCOUNT_LOCKED = 'locked',
  NOT_VERIFIED = 'not_verified',
}
